import { component } from 'picoapp'
import $ from '../lib/quantdom'
import { post } from '../lib/ajax'
import regexCreator from 'emoji-regex'

const emojiRegex = regexCreator()

function emojiStrip(string) {
  return string.replace(emojiRegex, '')
}

export default component((form) => {
  $(form).on('submit', (e) => {
    e.preventDefault()
    $('.js-add-note').attr('aria-busy', 'true')
    const note = $(form).find('textarea').val()

    const data = {
      note,
      attributes: {
        'Gift Note': 'Yes',
      },
    }
    //post to cart
    post('/cart/update.js', data)
      .then((res) => {
        $('.js-add-note').attr('aria-busy', 'false')
        $('cart-drawer').el().setAttribute('gift-note', '')
        $('#side-cart-gift-note').el().removeAttribute('open')
        setTimeout(() => {
          $(form).attr('data-note-exists', 'true')
        }, 350)
      })
      .catch((err) => {
        console.log(err)
      })
  })

  $(form)
    .find('textarea')
    .on('focus', (e) => {
      $(e.target).on('keyup', (e) => {
        const note = $(e.target).val()
        $(form).find('.js-note-char-count').text(note.length)
        $(e.target).val(emojiStrip(note))
      })
    })

  $(form)
    .find('.js-remove-note')
    .on('click', (e) => {
      e.preventDefault()
      $('.js-remove-note').attr('aria-busy', 'true')
      const data = {
        note: '',
        attributes: {
          'Gift Note': 'No',
        },
      }

      //post to cart
      post('/cart/update.js', data)
        .then((res) => {
          $('.js-remove-note').attr('aria-busy', 'false')
          $(form).find('textarea').val('')
          $(form).find('.js-note-char-count').text('0')
          $('cart-drawer').el().removeAttribute('gift-note')
          $('#side-cart-gift-note').el().removeAttribute('open')
          setTimeout(() => {
            $(form).attr('data-note-exists', 'false')
          }, 350)
        })
        .catch((err) => {
          console.log(err)
        })
    })
})
